export const groupHeadings = headingsArray => {
  if (headingsArray) {
    let prevValue = '###'
    let numb = 0
    const headings = headingsArray.reduce((a, e) => {
      if (prevValue !== e) {
        numb++
      }
      const title = e + '|' + numb.toString()
      prevValue = e
      return (a[title] = ++a[title] || 1), a
    }, {})
    const entries = Object.keys(headings).map(key => {
      return { title: key.split('|')[0], count: headings[key] }
    })
    return entries
  }
  return []
}

export const updateReportTypeDisplayName = (reportNumber, name) => {
  const updatedName = name.replace(/_/g, ' ').toUpperCase()
  return `${reportNumber} - ${updatedName}`
}

export const fullReportTypeNumberName = (
  reportTypes,
  reportNumber,
  masterModelId,
) => {
  const [reportType] = reportTypes.filter(
    item =>
      item.number === reportNumber && item.masterModelId === masterModelId,
  )
  if (reportType) {
    return updateReportTypeDisplayName(reportNumber, reportType.name)
  }
  return reportNumber
}

export const getEventReportGridColumns = airlines => {
  return [
    {
      field: 'airline',
      title: 'Airline',
      visible: airlines.length > 1,
    },
    {
      field: 'platform',
      title: 'Platform',
    },
    {
      field: 'reportType',
      title: 'Report Type',
    },
    {
      field: 'tailNumber',
      title: 'Tail',
    },
    {
      field: 'eventId',
      title: 'Event ID',
    },
    {
      field: 'eventReason',
      title: 'Reason',
    },
    {
      field: 'time',
      title: 'Report Date',
    },
  ]
}
